import { connect } from 'react-redux';
import AddUsersView from './AddUsersView.jsx';
import { fetchUsers } from 'src/redux/actions/users.ts';
import { fetchUserGroup, addUserToUserGroup, removeUserFromUserGroup, updateUserGroup } from 'src/legacy/redux/actions/userGroups';
import { selectUser, deselectUser, invalidateUserSelection } from 'src/legacy/redux/actions/selection';
import {trackAdoptionMetricsForUserGroupCreatedevent} from "src/legacy/redux/actions/adoption";
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  var id = ownProps.userGroup && ownProps.userGroup.id;
  var userGroup = _.get(state.legacyRootReducer, `settings.userGroup.userGroup[${id}]`);
  return {
    userGroup: userGroup && userGroup.item ? userGroup.item : null,
    users: _.get(state, "users.users.items"),
    loading: _.get(state, "users.users.loading"),
    currentPage: _.get(state, "users.users.pagination.currentPage"),
    totalPages: _.get(state, "users.users.pagination.totalPages"),
    user: state.users.me,
    selectedUsers: state.legacyRootReducer.selection.users || []
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers:(query, page, ignoreMe) => {
      return dispatch(fetchUsers(query, page, ignoreMe));
    },

    addUserToUserGroup: (id, user) => {
      return dispatch(addUserToUserGroup(id, user));
    },

    removeUserFromUserGroup: (id, user) => {
      return dispatch(removeUserFromUserGroup(id, user));
    },

    selectUser: (user) => {
      return dispatch(selectUser(user));
    },

    deselectUser: (user) => {
      return dispatch(deselectUser(user));
    },

    updateUserGroup: (id, request) => {
      return dispatch(updateUserGroup(id, request));
    },
    
    fetchUserGroup: (id) => {
      return dispatch(fetchUserGroup(id));
    },

    invalidateUserSelection: () => {
      return dispatch(invalidateUserSelection());
    },
    trackAdoptionMetricsForUserGroupCreatedevent : (groupName,permission,users) =>{
      return dispatch(trackAdoptionMetricsForUserGroupCreatedevent(groupName,permission,users));
    }
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, {
    ...stateProps,
    ...dispatchProps,
    isUserSelected: (user) => {
      var users = [];

      if (stateProps && stateProps.userGroup) {
        users = stateProps.userGroup.users;
      } else {
        users = stateProps.selectedUsers;
      }

      if (!users || users.length == 0) {
        return false;
      }

      let index = users.findIndex((item) => {
        return item.id == user.id;
      })

      return index != -1;
    },
    isUserDisabled: (user) => {
      var users = [];

      if (stateProps && stateProps.userGroup) {
        users = stateProps.userGroup.users;
      }

      if (!users || users.length == 0) {
        return false;
      }

      let index = users.findIndex((item) => {
        return item.id == user.id && item.persisted;
      })

      return index != -1;
    }
  }) 
}

const AddUsersContainer = connect (
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(AddUsersView);

export default AddUsersContainer;